import { Button } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { t } from '@lingui/core/macro';
import { IconPlus } from '@tabler/icons-react';

import { ActionButton, type ActionButtonProps } from './ActionButton';

/**
 * A generic icon button which is used to add or create a new item
 */
export function AddItemButton(props: Readonly<ActionButtonProps>) {
  const mobile = useMediaQuery('(max-width: 767px)');
  if (props.hidden) return null;
  if (mobile) {
    return <Button color='green' variant='light' leftSection={<IconPlus />}
      disabled={props.disabled} onClick={props.onClick} className='ts-add-item'>
      {props.text ?? props.tooltip ?? t`Add`}
    </Button>;
  }
  return <ActionButton {...props} color='green' icon={<IconPlus />} />;
}
